import { Box, Flex } from '@rebass/grid';
import { addGenericTags } from 'helpers/tracking/utm';
import React from 'react';
import { ElementType, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { CoinAnalysis } from 'store/Coin/Analysis/types';
import { Coin } from 'store/Coin/types';

import withContainer from './container';
import {
  ButtonReadReport,
  Buttons,
  Container,
  PoweredBy,
  Rating,
  RequestRatingButton,
  Score,
  Title,
} from './styles';

interface Props {
  coin: Coin;
  analysis: CoinAnalysis;
  Wrapper: ElementType;
}

const MarketsDetailAnalysis = (props: Props) => {
  const { t } = useTranslation();
  const { analysis, Wrapper, coin } = props;

  return (
    <Wrapper>
      <Title>
        {t('assets.detail.analysis.title', {
          code: coin.code.toUpperCase(),
        })}
      </Title>
      <Container>
        {!analysis && (
          <RequestRatingButton
            href={addGenericTags('https://tokeninsight.com/rating')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="big">
              {t('assets.detail.analysis.request-rating', {
                coinName: coin.name,
              })}
            </span>
            <span className="small">
              {t('assets.detail.analysis.request-rating-short', {
                coinCode: coin.code.toUpperCase(),
              })}
            </span>
          </RequestRatingButton>
        )}
        {analysis && (
          <Fragment>
            <Flex mb={20} flexWrap="wrap">
              <Box width={[1, 1 / 2]}>
                <Rating rating={analysis.rating}>{analysis.rating}</Rating>
              </Box>
              <Buttons width={[1, 1 / 2]} mt={['10px', 0]}>
                {analysis.ratingUrl && (
                  <ButtonReadReport
                    href={addGenericTags(analysis.ratingUrl)}
                    target="_blank"
                  >
                    {t('assets.detail.analysis.read-report')}
                  </ButtonReadReport>
                )}
              </Buttons>
            </Flex>
            <Flex mb={15} flexWrap="wrap">
              <Score width={[1, 1 / 2, 1 / 4, 1 / 5]}>
                <h4>{t('assets.detail.analysis.score.team')}</h4>
                <span>{analysis.teamScore}</span>
              </Score>
              <Score width={[1, 1 / 2, 1 / 4, 1 / 5]} mt={['15px', '10px', 0]}>
                <h4>{t('assets.detail.analysis.score.project')}</h4>
                <span>{analysis.ratingScore}</span>
              </Score>
              <Score width={[1, 1 / 2, 1 / 4, 1 / 5]} mt={['15px', '10px', 0]}>
                <h4>{t('assets.detail.analysis.score.eco')}</h4>
                <span>{analysis.ecosystemScore}</span>
              </Score>
            </Flex>

            <PoweredBy>
              <a
                href={addGenericTags('https://tokeninsight.com')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('assets.detail.analysis.powered-by')}
              </a>
            </PoweredBy>
          </Fragment>
        )}
      </Container>
    </Wrapper>
  );
};

export default withContainer(MarketsDetailAnalysis);
